import { Layout } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';

import { useAuthorization } from 'hooks';
import { isLocationUpdating as isLocationUpdatingSelector } from 'modules/app/selectors';

const FBContent = () => {
  useAuthorization();

  const isLocationUpdating = useSelector(isLocationUpdatingSelector);

  return (
    <Layout.Content id="main-content" className="ant-form-vertical">
      {!isLocationUpdating && <Outlet />}
    </Layout.Content>
  );
};

export default FBContent;
